import { Modal } from '../../components/modal/modal';
import { lightTheme } from '../../styles/theme';
import {
  AnnouncementCarouselControls,
  AnnouncementSlides,
} from './components/AnnouncementCarousel';
import { useActiveAnnouncements } from './hooks/useActiveAnnouncements';

/**
 * The announcements a signed-in user is owed, in one modal they page through
 * - swipe, the dots, or Next - rather than one modal per announcement.
 *
 * Mounted once in the layout (admin and partner), the way the chat feature's
 * What's New was. Each slide counts as seen when it is shown; closing early
 * (the X, the backdrop, Escape) leaves the rest for next time. "Don't show
 * again" is offered only on a slide that repeats, because a one-shot is never
 * coming back anyway.
 */
export const ActiveAnnouncements = () => {
  const { items, index, current, goTo, close, dontShowAgain } =
    useActiveAnnouncements();

  const repeats = current?.repeatInterval != null;

  return (
    <Modal
      isOpen={!!current}
      closeModal={close}
      logo={false}
      width="720px"
      /* White rather than the app's cream: the announcement carries an image
         and a block of copy, and both were written against white. It is also
         what the admin sees in the wizard's preview. */
      backgroundColor={lightTheme.white}
      footer={
        current && (
          <AnnouncementCarouselControls
            count={items.length}
            index={index}
            onIndex={goTo}
            onDone={close}
            showDontShowAgain={repeats}
            onDontShowAgain={() => dontShowAgain(current.id)}
          />
        )
      }
      /* The content leaves room for the pinned footer: one button needs the
         short gap, dots or the quiet link under it need the tall one. */
      $numOfFloatingButtons={items.length > 1 || repeats ? 2 : 1}
    >
      {current && (
        <AnnouncementSlides items={items} index={index} onIndex={goTo} />
      )}
    </Modal>
  );
};
